module.exports = __webpack_public_path__ + "static/media/23.43ea1ab2.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/work/23.png
// module id = 37
// module chunks = 0